import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { Redirect, useLocation } from 'react-router';
import { OFACScreeningStatusEnum } from 'anchor-kyb-service/types';
import { Spinner, useOverlayContext } from 'seagull';
import GenericError from '~/components/GenericError/GenericError';
import RestfulWrapper from '~/components/RestfulWrapper/RestfulWrapper';
import { routes } from '~/constants';
import { useIoContext, useStoreActions } from '~/contexts';
import { useOnMount } from '~/hooks/useOnMount';
import { useLocaleKeys } from '~/i18n';
import { LatestOFACSanctionStatusModel } from '~/models';
const renderLoader = ()=>/*#__PURE__*/ _jsx(Spinner, {
        testId: "loading-ofac-data",
        centeredInBox: true,
        centerBoxHeight: "100%"
    });
const renderError = ()=>/*#__PURE__*/ _jsx(GenericError, {
        testId: "ofac-error"
    });
function RedirectToHome(param) {
    let { detailsAdded } = param;
    const { showSuccessToast } = useOverlayContext();
    const { t: commonTexts } = useLocaleKeys('common');
    useOnMount(()=>{
        if (detailsAdded) {
            showSuccessToast(commonTexts.toasts.additionalDetailsAdded(), 'details-added');
        }
    });
    return /*#__PURE__*/ _jsx(Redirect, {
        to: routes.home
    });
}
function OpenPersonaInquiry(param) {
    let { inquiryId, sessionToken } = param;
    const { personaClient, browser: { locationReload } } = useIoContext();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [complete, setComplete] = useState(false);
    const persona = useMemo(()=>{
        return personaClient({
            onError: ()=>setError(true),
            onReady: ()=>setLoading(false),
            onComplete: ()=>setComplete(true),
            onCancel: ()=>locationReload()
        });
    }, []);
    useOnMount(()=>{
        persona.open(inquiryId, sessionToken);
    });
    if (error) return renderError();
    if (loading) return renderLoader();
    if (complete) return /*#__PURE__*/ _jsx(RedirectToHome, {
        detailsAdded: true
    });
    return null;
}
export async function fetchInquiry(param) {
    let { data, getUserStatus, getBusinessStatus, createInquiry } = param;
    const defaultStatus = new LatestOFACSanctionStatusModel({
        status: OFACScreeningStatusEnum.Cleared
    });
    const userStatusPromise = data.user.isSanctioned ? getUserStatus(data.user.id) : Promise.resolve(defaultStatus);
    const businessStatusPromise = data.business.isSanctioned ? getBusinessStatus(data.business.id) : Promise.resolve(defaultStatus);
    const [userStatus, businessStatus] = await Promise.all([
        userStatusPromise,
        businessStatusPromise
    ]);
    const inquiryPayload = {
        userId: userStatus.requiresInquiry() ? data.user.id : undefined,
        businessId: businessStatus.requiresInquiry() ? data.business.id : undefined
    };
    if (inquiryPayload.userId || inquiryPayload.businessId) {
        const inquiry = await createInquiry(inquiryPayload);
        return {
            inquiry
        };
    } else {
        return {
            inquiry: null
        };
    }
}
export default function AdditionalPaymentProcessorInfoPage() {
    const { state } = useLocation();
    const { api } = useStoreActions();
    return state ? /*#__PURE__*/ _jsx(RestfulWrapper, {
        fetch: async ()=>fetchInquiry({
                data: state.data,
                getUserStatus: (userId)=>api.ofacScreening.getUserStatus(userId),
                getBusinessStatus: (businessId)=>api.ofacScreening.getBusinessStatus(businessId),
                createInquiry: api.ofacScreening.createInquiry
            }),
        renderChild: (param)=>{
            let { data } = param;
            return data.inquiry ? /*#__PURE__*/ _jsx(OpenPersonaInquiry, _object_spread({}, data.inquiry)) : /*#__PURE__*/ _jsx(RedirectToHome, {
                detailsAdded: true
            });
        },
        renderLoader: renderLoader,
        renderError: renderError
    }) : /*#__PURE__*/ _jsx(RedirectToHome, {});
}
